export default "__VITE_ASSET__DjPYNzZl__"